import React from 'react';
import { Box } from '@mui/material';
import Header from '../common/Header';
import Footer from '../common/Footer';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.default',
    }}
  >
    <Header />
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        // Optional padding, but no Container limit
        p: { xs: 1, sm: 2, md: 3 },
        width: '100%',       // Full width
        maxWidth: '100vw',   // Viewport width
      }}
    >
      {children}
    </Box>
    <Footer />
  </Box>
);

export default MainLayout;
